const normalizePeriods = (snapshotPeriods, currentPeriods = []) => {
  if (!Array.isArray(snapshotPeriods)) return currentPeriods;
  const currentByNumber = new Map(
    (currentPeriods || []).map((period) => [Number(period.nro_periodo), period])
  );
  return snapshotPeriods.map((period) => ({
    ...(currentByNumber.get(Number(period.number)) || {}),
    idperiod: Number(period.id),
    nro_periodo: Number(period.number),
    puntos1: Number(period.homePoints) || 0,
    puntos2: Number(period.awayPoints) || 0,
  }));
};

export const mergeMatchSnapshot = (match, snapshot) => {
  if (!match || Number(match.idmatch) !== Number(snapshot?.id)) return match;
  const score = snapshot.score || {};
  return {
    ...match,
    state: Number(snapshot.state),
    resultado1: Number(score.home) || 0,
    resultado2: Number(score.away) || 0,
    sets1: Number(score.setsHome) || 0,
    sets2: Number(score.setsAway) || 0,
    defpenal1: Number(score.penaltiesHome) || 0,
    defpenal2: Number(score.penaltiesAway) || 0,
    periods: normalizePeriods(snapshot.periods, match.periods),
  };
};

export const applyMatchSnapshot = (matches, snapshot) =>
  (matches || []).map((match) => mergeMatchSnapshot(match, snapshot));

